var dev_uri = "https://v2.voorent.com";
var prod_uri = "https://v2.voorent.com";
var local = "http://192.168.1.8:4000/";
var order = "https://v2.voorent.com";
var prod = "http://localhost:9092";
var user = "http://localhost:9093";
var MS = {};
// Storefront cities. `id` is the backend service area used for inventory and
// pricing. The backend only has Gurugram (1) and Delhi (2) service areas
// (/product/serviceArea/), so Noida shares Delhi's inventory until it gets its own.
export const CITY_OPTIONS = [
  { name: "delhi", label: "Delhi", id: 2 },
  { name: "gurgaon", label: "Gurgaon", id: 1 },
  { name: "noida", label: "Noida", id: 2 },
];
var knownCities = CITY_OPTIONS.map(function (c) { return c.name; });

// REACT_APP_USE_PROD_API=true lets a local dev server use the live APIs.
if (
  window.location.hostname.indexOf("voorent") != -1 ||
  process.env.REACT_APP_USE_PROD_API === "true"
) {
  MS = {
    PRODUCT: `${prod_uri}/product`,
    ORDER: `${order}/order`,
    USER: `${prod_uri}/user`,
    MAILER: `${prod_uri}/mailer`,
    AUTH: `${prod_uri}/auth/auth`,
    NULL: `${local}/`,
  };
} else {
  MS = {
    PRODUCT: `${prod}`,
    ORDER: `${order}`,
    USER: `${prod_uri}/user`,
    MAILER: `${prod_uri}/mailer`,
    AUTH: `${prod_uri}/auth/auth`,
    NULL: `${local}/`,
  };
}

const ENDPOINTS = {
  serviceArea: "/serviceArea/all",
  trending: "/product/trending",
  packages: "/product/packages",
  popular: "/product/mostViewed",
  categoryBase: "/category/",
  category: "/category/all",
  productByCategory: "/product/all",
  viewProduct: "/product/view/",
  limit: "?limit=100&offset=0",
  checkInventory: "/inventory/checkAvailability",
  addToCart: "/cart/add",
  checkCart: "/cart/check",
  cartProductInfo: "/product/cartProductInfo",
  verifyPinCode: "/pincode/verify",
  addAddress: "/address/new",
  allAddress: "/address/all",
  placeOrder: "/order/place",
  viewAllOrders: "/order/all",
  deleteAddress: "/address/delete",
  listDeposit: "/deposit/all",
  listPayment: "/payment/all",
  listInvoices: "/invoice/all",
  checkUsername: "/user/checkUsername",
  checkEmail: "/user/checkEmail",
  registerUser: "/user/add",
  deleteCartItem: "/cart/delete",
  uploadDocument: "/kyc/uploadDocument",
  allDocuments: "/kyc/all",
  userInfo: "/user/userInfo",
  userOtp: "/user/userOtp",
  razorPayOrderId: "/order/razorpay/orderId",
  razorPaySubscriptionId: "/order/razorpay/subscriptionId",
  updatePayment: "/order/razorpay/upadateOrder",
  updatePaymentInvoice: "/invoice/razorpay/upadateOrder",
  deleteDocument: "/kyc/delete",
  adjustQuantity: "/cart/manageQuantity",
  orderInfo: "/order/info",
  razorPayInvoice: "/invoice/razorpay/invoice",
  cancelOrder: "/order/cancel",
  passwordReset: "/user/password/update",
  passwordResetMail: "/user/password/reset",
  resetPasswordMailer: "/user/mailer/password/reset",
  checkCoupon: "/promotion/check",
  applyCoupon: "/cart/applyCoupon",
  bulkInvoicePayment: "/invoice/razorpay/bulk",
  printInvoice: "/invoice/print",
  checkAddress: "/address/check",
  orderMail: "/order/mailer",
  getReasons: "/issue/reasons",
  reportIssue: "/issue/save",
  showAllIssues: "/issue/getAll",
  orderExtend: "/order/extend",
  getExtendOrder: "/order/extend/getAll",
  changePassword: "/user/changePassword",
  searchItems: "/product/search",
  recommendedItems: "/product/get/recommendation",
  razorPayExtendId: "/order/razorpay/extend",
  updatePaymentExtend: "/order/razorpay/updateExtend",
  invoiceIsPaid: "/invoice/orderNumber",
  razorPayKeys: "/order/razorpay/keys",
  showAllEnquiry: "/order/getAll/enquiry",
  submitSurvey: "/user/submitSurvey",
  submitProductSurvey: "/new/products/submitProductSurvey",
  getAllNewProducts: "/new/products",
  getNewProductsCategory: "/new/product/category",
  getNewProductsSubCategory: "/new/product/subcategory",
  sendOtp: "/sendOtp",
  validateOtp: "/validateOtp",
  validateOtpRegister: "/validateOtpRegister",
  productCategory: "product_master/",
  allExpressPrice: "/express/prices",
  expressPrice: "/express/price",
  updateProductQuantity: "/order/updateQuantity",
  expressDelivery: "/express-delivery",
};

function cityFromUrl() {
  if (typeof window === "undefined") return null;
  var firstSegment = window.location.pathname.split("/").filter(Boolean)[0];
  return knownCities.indexOf(firstSegment) !== -1 ? firstSegment : null;
}

// A city in the URL wins over the stored choice, so /noida/furniture always
// shows Noida (links, breadcrumbs, header) even for a returning Delhi visitor.
export function getCurrentCity() {
  var urlCity = cityFromUrl();
  if (urlCity) return urlCity;

  if (typeof localStorage !== "undefined" && localStorage.getItem("city")) {
    return localStorage.getItem("city");
  }

  return "delhi";
}

export function getCityOption(name) {
  return CITY_OPTIONS.filter(function (c) { return c.name === name; })[0] || null;
}

// Keeps the stored city/service area in step with a city URL (inventory
// lookups read localStorage.cityId). Called on every route change.
export function syncCityFromUrl() {
  var urlCity = cityFromUrl();
  if (!urlCity || typeof localStorage === "undefined") return;
  var option = getCityOption(urlCity);
  try {
    if (localStorage.getItem("city") !== urlCity) localStorage.setItem("city", urlCity);
    if (String(localStorage.getItem("cityId")) !== String(option.id)) localStorage.setItem("cityId", option.id);
  } catch (e) {
    // storage unavailable; the URL still drives the city
  }
}

// The catalogue API slug is "appliance", but /city/appliances is the public
// (canonical) listing URL. Sub-category and product URLs keep the API slug.
export function apiCategorySlug(slug) {
  return slug === "appliances" ? "appliance" : slug;
}

export function publicCategorySlug(slug) {
  return slug === "appliance" ? "appliances" : slug;
}

export function getRoute(key, city) {
  city = city || getCurrentCity();
  if (key) key = key.replace(/^appliance(?=$|[?#])/, "appliances");
  return key ? `/${city}/${key}` : `/${city}`;
}

// Router-relative path for the current city, e.g. "/delhi/furniture".
export function getPath(key) {
  return getRoute(key);
}

export function getRoot(key) {
  return key ? `/${key}` : "/";
}

export function getEndpoint(microservice, key) {
  return `${MS[microservice]}${ENDPOINTS[key]}`;
}

export function getLimit() {
  return `${ENDPOINTS["limit"]}`;
}

// ✅ Added missing export used in RentSelector.jsx
